// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_L5PSL","current":"index_current_L7CR7"};